"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCollapseStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
var commons_1 = require("../../../style/commons");
exports.useCollapseStyles = (0, styles_1.makeStyles)(function () { return ({
    container: {
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        '& button': {
            marginRight: 8,
            border: 'none',
            backgroundColor: 'transparent',
            color: commons_1.darkSecondary,
            fontSize: 24,
        },
    },
    title: {
        fontWeight: 500,
        color: commons_1.darkSecondary,
    },
    main: {
        '& .MuiCollapse-container': {
            marginTop: 16,
        },
    },
}); });
